module.exports = __webpack_public_path__ + "static/media/logo-obras.4fe183c5.png";